/**
 * The "Show all N" / "Show fewer" button of a list capped at its first 5 rows (`useRowCap`, use-row-cap.ts).
 * Look: the bridge's "patient chart" block (`data-slot="chart-show-all"`).
 */
import type { RowCap } from './use-row-cap';

/** Nothing when the list fits in 5. */
export function ChartShowAll<T>({ cap, label }: { cap: RowCap<T>; label?: string }) {
  if (!cap.capped) return null;
  return (
    <button
      type="button"
      data-slot="chart-show-all"
      aria-expanded={cap.expanded}
      aria-label={label ? (cap.expanded ? `Show fewer ${label}` : `Show all ${cap.total} ${label}`) : undefined}
      onClick={cap.toggle}
    >
      {cap.expanded ? 'Show fewer' : `Show all ${cap.total}`}
    </button>
  );
}
